// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__RV56L","Content":"Layout_Content__ihBBM"};